module.exports = __webpack_public_path__ + "customer3.png?1b06cc960d64f64c35a885156a9a2bd5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/customer3.png
// module id = 115
// module chunks = 0